<template>
  <!-- <div class="accountset" style="display: flex; height: 100%"> -->
  <div class="accountset_contenter">
    <div class="accountset_contenter_one">
      <div>
        <img src="../../assets/img/leftnav/zhaq.png" alt="" @click="displayleft"/>
        <div>账户安全</div>
      </div>
    </div>
    <div class="accountset_contenter_two">修改密码</div>
    <div class="accountset_contenter_three">
      <div>旧密码</div>
      <input
        type="password"
        v-model="oldPassword"
        placeholder="请输入6-16位的登录密码"
      />
      <div>新密码</div>
      <input
        type="password"
        v-model="newPassword"
        placeholder="请设置6-16位的登录密码"
      />
      <div>确认密码</div>
      <input
        type="password"
        v-model="confirmPassword"
        placeholder="请再次输入密码"
        style="margin-bottom: 50px"
      />
    </div>
    <div class="accountset_contenter_four" @click="ggPassword()">保存</div>
     <!-- 左侧边栏 -->
    <el-drawer
      :visible.sync="drawer"
      :with-header="false"
      direction="ltr"
      size="288px"
    >
      <left-nav></left-nav>
    </el-drawer>
  </div>
  <!-- </div> -->
</template>

<script>
import leftNav from "../../components/content/leftNav";
export default {
   components: {
    leftNav,
  },
  data() {
    return {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
       drawer: false,
    };
  },
  methods: {
     //左边显示
    displayleft() {
      if(document.body.clientWidth <= 1200){
        this.drawer = true;
      }
    },
    ggPassword() {
      var ve = /^\d{8,16}$/;
      let sve = this.confirmPassword;
      if (
        this.oldPassword != "" &&
        this.newPassword != "" &&
        this.confirmPassword != ""
      ) {
        console.log("不为空的情况下判断是否一致");
        if (this.newPassword == this.confirmPassword) {
          console.log("不为一致的情况下判断密码长度");
          if (ve.test(sve)) {
            console.log("密码长度正确的情况下判断新旧密码是否一致");
            if (this.confirmPassword != this.oldPassword) {
              let header = {
                Authorization: "Bearer " + localStorage.getItem("token"),
              };

              let data = {
                password: this.oldPassword,
                new_password: this.confirmPassword,
              };
              this.$api
                .modifyPassword(data, header)
                .then((res) => {
                  console.log(res, "修改密码");
                  if (res.code == 0) {
                    this.$router.push({ name: "login" });
                  } else {
                    this.$util.mesBoxPop(res.msg);
                  }
                })
                .catch((err) => {
                  console.log(err);
                });

              console.log(this.confirmPassword);
            } else {
              this.$util.mesBoxPop("新密码与旧密码一致", "warning");
            }
          } else {
            this.$util.mesBoxPop("密码长度8~16位", "warning");
          }
        } else {
          this.$util.mesBoxPop("密码输入不一致", "warning");
        }
      } else {
        this.$util.mesBoxPop("内容不能为空", "warning");
      }
    },
  },
};
</script>

<style  lang="scss" scoped>
// .accountset {
//   background-color: #f2f4f8;
.accountset_contenter {
  width: 100%;
  background-color: var(--color-theme);
  height: 100%;
  border: 1rpx solid #f7f7f7;
  padding: 0 4%;

  .accountset_contenter_one {
    padding-top: 50px;
    margin-bottom: 50px;
    height: 40px;

    font-size: 30px;
    font-weight: bold;
    color: #333333;
    div {
      display: flex;
      align-items: center;
      img {
        width: 25px;
        height: 25px;
        margin-right: 20px;
      }
    }
  }

  .accountset_contenter_two {
    font-size: 21px;
    color: #333333;
  }
  .accountset_contenter_three {
    width: 38%;
    height: auto;
    margin: 0 auto;
    text-align: left;
    font-size: 18px;
    color: #333333;
    input {
      width: 100%;
      height: 45px;
      background-color: #ffffff;
      border-radius: 20px;
      border: none;
      margin: 18px 0;
      padding: 0 8%;
    }
  }
  .accountset_contenter_four {
    width: 150px;
    height: 45px;
    line-height: 45px;
    color: #fff;
    background-color: #00a68a;
    border-radius: 22px;
    text-align: center;
    margin: 0 auto;
  }
}
// }
</style>